import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "169f3e28-1e53-4b07-8107-1f9ef3f75feb",
    content: "1 kHz sine tone @ 40 dB SPL",
    options: {
      image: `${config.ASSETS_URL}/02/07/task/task-02-chart-1.svg`,
    },
  },
  {
    id: "e45bb7de-3bff-49f7-b1c0-5918ee8d00ad",
    content: "1 kHz sine tone @ 60 dB SPL",
    options: {
      image: `${config.ASSETS_URL}/02/07/task/task-02-chart-2.svg`,
    },
  },
  {
    id: "73100bfd-c007-48bb-a613-a7bee214a58a",
    content: "Broadband white noise @ 40 dB SPL",
    options: {
      image: `${config.ASSETS_URL}/02/07/task/task-02-chart-3.svg`,
    },
  },
  {
    id: "8dbe51dc-3343-4d24-bc72-560eb99d99af",
    content: "4 kHz sine tone @ 40 dB SPL",
    options: {
      image: `${config.ASSETS_URL}/02/07/task/task-02-chart-4.svg`,
    },
  },
];

export const task: Task = {
  id: "2890c124-d7ab-4935-8f97-39e833399bb3",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
    imageHeight: 190,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["169f3e28-1e53-4b07-8107-1f9ef3f75feb"],
};
